import React, {useEffect, useState} from 'react'
import {getAllDepartment} from "../../services/serviceDepartment";
import {Button, DatePicker, Form, Input, Modal, Select} from "antd";
import {updateEmployee} from "../../services/serviceEmployee";
import moment from "moment";
import bcrypt from "bcryptjs";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";


const {Option} = Select
const dateFormat = 'DD/MM/YYYY'

const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}

const EmployeeEditFormatter = ({employee, show, modalCloser, updater}) => {
    const [form] = Form.useForm()
    const [departmentList, setDepartmentList] = useState([])
    const [loadings, setLoadings] = useState([])

    useEffect(() => {
        getAllDepartment()
            .then(({data}) => setDepartmentList(data))
    }, [])

    const handleSubmit = (list) => {
        enterLoadingState(setLoadings)
        let requestObj = {
            id: employee.id,
            name: list.employeeName,
            surname: list.employeeSurname,
            employeeCode: list.employeeCode,
            username: list.employeeUsername,
            birthdate: list.birthDate,
            phoneNumber: list.phoneNumber,
            internalPhoneCode: list.internalPhoneCode,
            title: list.title
        }

        if (list.employeeDepartment === employee.department.code) {
            requestObj.department = employee.department.id

        } else {
            requestObj.department = list.employeeDepartment
        }

      getHashPassword(list.employeePassword)
          .then(data => {
              requestObj.password = data
              updateEmployee(requestObj)
                  .then(() => {
                      exitLoadingState(setLoadings)
                      modalCloser(false)
                      updater()
                  })
                  .catch(() => exitLoadingState(setLoadings))
          })
    }

    const getHashPassword = async(value) => {
        const password = await bcrypt.hash(value, 10)
        return new Promise(resolve => resolve(password))
    }


    return (
        <React.Fragment>

            <Modal
                open={show}
                closable={false}
                title={`Güncelle`}
                footer={[
                    <Button
                        key={'SubmitButton'}
                        type={'primary'}
                        loading={loadings[0]}
                        onClick={() => form.submit()}
                    >
                        Güncelle
                    </Button>,
                    <Button
                        key={'CloseButton'}
                        onClick={() => modalCloser(false)}
                    >
                        Kapat
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    {...formLayout}
                    onFinish={() => handleSubmit(form.getFieldsValue())}
                    initialValues={{
                        employeeName: employee.name,
                        employeeSurname: employee.surname,
                        employeeCode: employee.code,
                        employeeDepartment: employee.department.code,
                        employeeUsername: employee.username,
                        employeePassword: employee.password,
                        birthDate: moment(employee.birthdate, "YYYY/MM/DD"),
                        title: employee.title,
                        phoneNumber: employee.phoneNumber,
                        internalPhoneCode: employee.internalPhoneCode
                    }}
                >
                    <Form.Item
                        label={'Adı'}
                        name={'employeeName'}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label={'Soyadı'}
                        name={'employeeSurname'}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label={'Çalışan Kodu'}
                        name={'employeeCode'}
                        rules={[
                            {required: true, message: 'Bu alan boş bırakılamaz'},
                            {min:2, message: 'En az 2 Karakter Girmek Zorunludur'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Departmanı'}
                        name={'employeeDepartment'}
                    >
                        <Select>
                            {departmentList.map(item => {
                                return <Option key={item.id} value={item.id}>{item.code}</Option>
                            })}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name={'title'}
                        label={'Ünvan'}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name={'birthDate'}
                        label={'Doğum Tarihi'}
                    >
                        <DatePicker format={dateFormat} placeholder={'Tarih seçiniz'}/>
                    </Form.Item>
                    <Form.Item
                        name={'phoneNumber'}
                        label={'Telefon Numarası'}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name={'internalPhoneCode'}
                        label={'Dahili'}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Kullanıcı Adı'}
                        name={'employeeUsername'}
                        rules={[
                            {required: true, message: 'Kullanıcı Adı Alanı Boş Bırakılamaz'},
                            {type: 'email', message: 'Doğru Bir Formatte E-mail Giriniz (örnek@örnek.com)'}
                        ]}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label={'Şifresi'}
                        name={'employeePassword'}
                        rules={[
                            {min: 4, message: 'Şifreniz En Az 4 Karakterden Oluşmalıdır'}
                        ]}
                    >
                        <Input/>
                    </Form.Item>
                </Form>

            </Modal>

        </React.Fragment>
    )
}
export default EmployeeEditFormatter